"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconVacationFilled = function IconVacationFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.83 41.19L39 30H26V16H36C36.0785 16.0016 36.1562 15.9846 36.2269 15.9506C36.2976 15.9166 36.3593 15.8664 36.407 15.804C36.4547 15.7417 36.4871 15.6691 36.5015 15.5919C36.5159 15.5148 36.512 15.4353 36.49 15.36C35.7233 12.9101 34.1942 10.7691 32.1256 9.24891C30.0571 7.72876 27.5571 6.90895 24.99 6.90895C22.4229 6.90895 19.9229 7.72876 17.8543 9.24891C15.7858 10.7691 14.2567 12.9101 13.49 15.36C13.4674 15.437 13.4636 15.5183 13.4791 15.5971C13.4945 15.6759 13.5287 15.7497 13.5787 15.8125C13.6287 15.8753 13.6931 15.9251 13.7664 15.9577C13.8398 15.9904 13.9199 16.0049 14 16H24V30H14.57L8.87999 17.21C8.68399 16.7393 8.32267 16.3565 7.86406 16.1336C7.40545 15.9107 6.8812 15.8632 6.38999 16C6.1219 16.0853 5.87484 16.2263 5.66494 16.4137C5.45504 16.601 5.28703 16.8305 5.17189 17.0872C5.05675 17.344 4.99706 17.6221 4.99674 17.9034C4.99641 18.1848 5.05545 18.463 5.16999 18.72L11.62 33.2L9.99999 37H6.99999C6.73478 37 6.48042 37.1053 6.29289 37.2929C6.10535 37.4804 5.99999 37.7348 5.99999 38C5.99999 38.2652 6.10535 38.5196 6.29289 38.7071C6.48042 38.8946 6.73478 39 6.99999 39H9.11999L8.16999 41.19C8.05714 41.4465 7.99944 41.7238 8.00063 42.004C8.00182 42.2842 8.06187 42.561 8.1769 42.8165C8.29192 43.072 8.45935 43.3005 8.66833 43.4871C8.8773 43.6738 9.12317 43.8144 9.38999 43.9C9.87874 44.0426 10.4029 44 10.8622 43.7805C11.3216 43.561 11.6839 43.1798 11.88 42.71L13.53 39H38.47L40.13 42.71C40.3243 43.1813 40.6863 43.5638 41.1463 43.7836C41.6062 44.0034 42.1313 44.0449 42.62 43.9C42.8859 43.8134 43.1307 43.672 43.3386 43.4848C43.5465 43.2977 43.7128 43.0691 43.8268 42.8137C43.9409 42.5583 44.0001 42.2819 44.0006 42.0022C44.0012 41.7225 43.943 41.4458 43.83 41.19ZM14.42 37L15.76 34H36.24L37.58 37H14.42Z",
    fill: color
  }));
};

IconVacationFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconVacationFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconVacationFilled;
exports.default = _default;